import { XCircle } from 'lucide-react'
import { RevealWrapper } from '../components/RevealWrapper'

const PAINS = [
  'Cata informações de cliente no WhatsApp por 20 minutos',
  'Descobre inadimplência só quando fecha o mês',
  'Precisa de 3 planilhas para saber o faturamento',
  'Piloto vai para área errada por falta de comunicação',
  'Perde noção dos talhões tratados e dos que faltam',
]

export function PainSection() {
  return (
    <section
      aria-labelledby="pain-heading"
      style={{ padding: '72px 24px 0', maxWidth: 480, margin: '0 auto' }}
    >
      <RevealWrapper>
        <span
          style={{
            display: 'inline-block',
            padding: '4px 12px',
            borderRadius: 999,
            background: '#FEF3C7',
            color: '#78350F',
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            marginBottom: 16,
          }}
        >
          Você ainda faz isso?
        </span>

        <h2
          id="pain-heading"
          style={{
            fontFamily: 'var(--font-bricolage)',
            fontSize: 'clamp(24px, 7vw, 30px)',
            fontWeight: 800,
            lineHeight: 1.18,
            letterSpacing: '-0.025em',
            marginBottom: 32,
          }}
        >
          O dia a dia sem um{' '}
          <span style={{ color: '#C0392B' }}>sistema organizado.</span>
        </h2>
      </RevealWrapper>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 28 }}>
        {PAINS.map((pain, i) => (
          <RevealWrapper key={i} delay={i * 0.07}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                padding: '14px 18px',
                background: '#fff',
                borderRadius: 16,
                border: '1px solid #EDE9E1',
                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
              }}
            >
              <XCircle size={18} color="#E53E3E" strokeWidth={1.8} style={{ flexShrink: 0 }} />
              <p
                style={{
                  fontSize: 14,
                  color: '#3A3830',
                  lineHeight: 1.5,
                  margin: 0,
                }}
              >
                {pain}
              </p>
            </div>
          </RevealWrapper>
        ))}
      </div>

      <RevealWrapper delay={0.38}>
        <div
          style={{
            padding: '22px 24px',
            background: '#0B1D11',
            borderRadius: 20,
            textAlign: 'center',
          }}
        >
          <p
            style={{
              fontFamily: 'var(--font-bricolage)',
              fontSize: 19,
              fontWeight: 700,
              color: '#fff',
              lineHeight: 1.4,
              margin: 0,
            }}
          >
            DroneOps resolve tudo isso.{' '}
            <span style={{ color: '#52C97E' }}>Em um único app.</span>
          </p>
        </div>
      </RevealWrapper>
    </section>
  )
}
